import { useFormik } from "formik";
import RadioInput from "../../common/RedioComponent/RadioInput";
import Header from "../../component/Header";
import Layout from "../../component/Layout";
import UsePagination from "../../component/pagination";
import * as S from "./lifeStyle.styles";
import * as yup from "yup";
import SelectComponent from "../../common/textFeilds/SelectComponent";
import { useEffect } from "react";
const LifeStyle = ({ step, setStep }) => {
  const radioOption = [
    { label: "بله", value: "true" },
    { label: "خیر", value: "false" },
  ];
  const checkOption = [
    { title: " یک گزینه را انتخاب کنید", value: "" },
    { title: "یک", value: "1" },
    { title: "دو", value: "2" },
    { title: "سه", value: "3" },
    { title: "کمتر از ده", value: "less than 10" },
    { title: "بیشتر از ده", value: "more than 10" },
  ];
  const initialValues = {
    smoker: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].smoker
      : "",
    cigarettesCount: JSON.parse(localStorage.getItem("infoPerson"))[step - 1]
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].cigarettesCount
      : "",
  };
  //2.
  const onSubmit = (values) => {
    const datas = JSON.parse(localStorage.getItem("infoPerson"));
    let info = localStorage.getItem("infoPerson");
    if (info) {
      let parseInfo = JSON.parse(info);
      parseInfo[2] = values;
      localStorage.setItem("infoPerson", JSON.stringify(parseInfo));
    } else {
      datas.push(values);

      localStorage.setItem("infoPerson", JSON.stringify(datas));
    }

    localStorage.setItem("step", JSON.stringify(step));
    setStep(
      parseInt(localStorage.getItem("step"))
        ? parseInt(localStorage.getItem("step")) + 1
        : 3
    );
  };

  //3.
  const validationSchema = yup.object({
    smoker: yup.string().required("یک گزینه را انتخاب کنید"),
    cigarettesCount: yup.string(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });

  return (
    <>
      <Header>
        <S.BgHeader style={{ backgroundImage: `url("images/header.png")` }}>
          <S.ContentHeader>
            <S.TitleHeader>اطلاعات سبک زندگی</S.TitleHeader>
            <img src="/images/life.png" width={115} alt="header" />
          </S.ContentHeader>
        </S.BgHeader>
      </Header>
      <Layout>
        <S.Container>
          <S.Title>آیا طی شش ماه گذشته به طور مرتب سیگار کشیده‌اید؟</S.Title>
          <S.RadioWrraper>
            <form
              onSubmit={formik.handleSubmit}
              style={{ marginBottom: "98px" }}
            >
              <RadioInput
                formik={formik}
                name={"smoker"}
                radioOption={radioOption}
              />

              {formik.values.smoker === "true" ? (
                <S.Smooke>
                  <S.Title>چند نخ سیگار در روز می‌کشید؟</S.Title>
                  <SelectComponent
                    formik={formik}
                    name={`cigarettesCount`}
                    selectOption={checkOption}
                  />
                  <S.ErrorMessage>
                    {formik.errors["cigarettesCount"] &&
                      formik.touched["cigarettesCount"] && (
                        <div className="error">
                          {formik.errors["cigarettesCount"]}
                        </div>
                      )}
                  </S.ErrorMessage>
                </S.Smooke>
              ) : (
                ""
              )}
              <UsePagination step={step} setStep={setStep} formik={formik} />
            </form>
          </S.RadioWrraper>
        </S.Container>
      </Layout>
    </>
  );
};

export default LifeStyle;
